import script from "./OrderInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderInfo.vue?vue&type=script&setup=true&lang=js"

import "./OrderInfo.vue?vue&type=style&index=0&id=1838d1c7&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1838d1c7"]])

export default __exports__